<template>
  <div id="progress">
    <div class="progress-line">
      <!-- 基本资料-->
      <div :class="`node ${getNodeClass(0,scheduleIndex)}`"></div>
      <div :class="scheduleIndex > 0 ? 'line-on' : 'line-off'"></div>
      <!-- 专人上门-->
      <div :class="`node ${getNodeClass(1,scheduleIndex)}`"></div>
      <div :class="scheduleIndex > 1 ? 'line-on' : 'line-off'"></div>
      <!-- 正在办理-->
      <div :class="`node ${getNodeClass(2,scheduleIndex)}`"></div>
      <div :class="scheduleIndex > 2 ? 'line-on' : 'line-off'"></div>
      <!-- 线上缴费-->
      <div :class="`node ${getNodeClass(3,scheduleIndex)}`"></div>
    </div>
    <div class="title">
      <div :class="getTitleClass(0,scheduleIndex)">基本资料</div>
      <div :class="getTitleClass(1,scheduleIndex)">专人上门</div>
      <div :class="getTitleClass(2,scheduleIndex)">正在办理</div>
      <div :class="getTitleClass(3,scheduleIndex)">线上缴费</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "myProgress",
    props:{
      indexVal:{type:Number,}
    },
    data() {
      return {
        scheduleIndex: this.indexVal,
      }
    },
    watch:{
      indexVal() {
        this.scheduleIndex = this.indexVal
      }
    },
    methods:{
      getNodeClass(yourIndex,index) {
        if (yourIndex < index) {return 'done'}
        else if (yourIndex === index) {return 'doing'}
        else if (yourIndex > index) {return 'unstarted'}
      },
      getTitleClass(yourIndex,index) {
        if (yourIndex < index) {return 't-done'}
        else if (yourIndex === index) {return 't-doing'}
        else if (yourIndex > index) {return ''}
      }
    },
  }
</script>

<style scoped>
  #progress{
    height: 21.067vw;
    overflow: auto;
    background: white;
  }
  .progress-line{
    width: 85.866vw;
    height: 6.133vw;
    margin: 4vw auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .node{
    width: 6.133vw;
    height: 6.133vw;
  }
  .unstarted{
    background-image: url("/images/AAV/unstarted.png");
    background-size: 100%;
  }
  .doing{
    border-radius: 50%;
    background-color: #00d10b;
    box-shadow: 0vw 0.267vw 1.6vw 0vw
    rgba(0, 209, 11, 0.5);
  }
  .done{
    background-image: url("/images/AAV/done.png");
    background-size: 100%;
  }
  .line-off{
    width: 17.6vw;
    height: 1px;
    background-color: #bfc2cc;
  }
  .line-on{
    width: 17.6vw;
    height: 1px;
    background-color: #66e36d;
  }
  .title{
    width: 92.134vw;
    margin: 2.4vw auto 0;
    font-size: 3.2vw;
    color: #bfc2cc;
    display: flex;
    justify-content: space-between;
  }
  .t-doing{color: #00d10b;}
  .t-done{color: #66e36d;}</style>
